import { Checkbox } from "antd";
import type { MonitoringLayer } from "../types";

interface LayerOption {
	value: MonitoringLayer;
	label: string;
}

/** "territory-org" and "territory-brigade" are mutually exclusive — see below. */
const LAYER_OPTIONS: LayerOption[] = [
	{ value: "territory-org", label: "Tashkilot hududlari" },
	{ value: "territory-brigade", label: "Brigada hududlari" },
	{ value: "equipment", label: "Texnika" },
	{ value: "staff", label: "Brigadir / xodim" },
	{ value: "planting", label: "Ekinlar" },
	{ value: "attendance", label: "Davomat" },
];

interface LayerToggleProps {
	value: MonitoringLayer[];
	onChange: (layers: MonitoringLayer[]) => void;
}

export function LayerToggle({ value, onChange }: LayerToggleProps) {
	const handleChange = (checked: MonitoringLayer[]) => {
		// Territory layers are alternates of the same data — turning one on
		// always turns the other off, they never show together.
		const turnedOnOrg = checked.includes("territory-org") && !value.includes("territory-org");
		const turnedOnBrigade =
			checked.includes("territory-brigade") && !value.includes("territory-brigade");

		if (turnedOnOrg) {
			onChange(checked.filter((l) => l !== "territory-brigade"));
			return;
		}
		if (turnedOnBrigade) {
			onChange(checked.filter((l) => l !== "territory-org"));
			return;
		}
		onChange(checked);
	};

	return <Checkbox.Group value={value} onChange={handleChange} options={LAYER_OPTIONS} />;
}
